/**
 * This method is a plugin to be used with Chartjs to render a message if there's no dataset
 * @param {*} chart chart reference object
 * @param {*} chartData reference to dataset
 * @param {*} message string to be displayed if no data found
 * @returns void
 */
export const noDataFoundPlugin = (chart, chartData, message) => {
  if (!chartData) {
    return;
  }

  if (
    !chart.data ||
    !chart.data.datasets ||
    !chart.data.datasets.length ||
    chart.data.datasets.every(({ data }) => !data || !data.length)
  ) {
    // No data is present
    const ctx = chart.chart.ctx;
    const width = chart.chart.width;
    const height = chart.chart.height;
    chart.clear();

    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = "16px normal 'Helvetica Nueue'";
    ctx.fillText(message, width / 2, height / 2);
    ctx.restore();
  }
}
